module.exports = __webpack_public_path__ + "img/teacher-cert-qr.08af5c9a.jpg";